module.exports = __webpack_public_path__ + "static/media/growportfolio.b074b7f4.png";